import React, { Component } from 'react';
import { Label, Modal, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import DatesWithProductionFromMultiplePracticesTable from "./DatesWithProductionFromMutliplePracticesTable";

class WorkedDaysLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };
    }

    handleLabelClick = () => {
        this.setState({ modalOpen: true });
    };

    handleCloseModal = () => {
        this.setState({ modalOpen: false });
    };

    getPracticeName = (practiceDatabaseName) => {
        const { practiceListArray } = this.props;
        const practiceDetails = practiceListArray?.find(item => item.practiceDBName === practiceDatabaseName);
        return practiceDetails ? practiceDetails?.practice : '';
    }

    render() {
        const { workedDays, sameDateMultiplePractices } = this.props;
        const { modalOpen } = this.state;
        const mappedData = sameDateMultiplePractices?.map(item => ({
                ...item,
                practiceNames: (item.practices)
                    .map(dataBaseName => this.getPracticeName(dataBaseName)) }))



        return (
            <React.Fragment>
                <Label
                    circular
                    color='red'
                    key='circular-label- worked'
                    onClick={this.handleLabelClick}
                    style={{ cursor: 'pointer' }}
                >
                    {workedDays}
                </Label>

                {modalOpen && <Modal open={modalOpen} onClose={this.handleCloseModal} size='tiny'>
                    <Modal.Header>Dates with multiple practices</Modal.Header>
                    <Modal.Content>
                        <DatesWithProductionFromMultiplePracticesTable data={mappedData}/>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>}
            </React.Fragment>
        );
    }
}

export default connect(state => ({
    practiceListArray:state.get('practices').get('practiceListArray'),
}))(WorkedDaysLabel);